// extracted by mini-css-extract-plugin
module.exports = {"footer":"style_footer__3uTvf","footer__text":"style_footer__text__39yoX"};